/**
 * format.ts — formatters y diccionarios de copy compartidos por los bloques
 * del Home.
 *
 * Extraídos de `pages/Home.tsx` (2026-09-22) al sacar el bloque de eventos a
 * su propio módulo: estos helpers los consumen tanto la page como
 * `EventsBlock`, así que vivir en un módulo neutro evita un import circular.
 *
 * Todo en es-CO y COP sin decimales (PROMPT_MAESTRO §2 — el sitio sale solo
 * en español de Colombia).
 */
import type { UpcomingEvent } from './api';

export const copFormatter = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0,
});

const monthShortFmt = new Intl.DateTimeFormat('es-CO', { month: 'short' });
const dayFmt = new Intl.DateTimeFormat('es-CO', { day: '2-digit' });
const timeFmt = new Intl.DateTimeFormat('es-CO', {
  hour: '2-digit',
  minute: '2-digit',
});

export function formatEventMeta(iso: string): { day: string; month: string; time: string } {
  const d = new Date(iso);
  return {
    day: dayFmt.format(d),
    month: monthShortFmt.format(d).replace('.', '').toUpperCase(),
    time: timeFmt.format(d),
  };
}

/** Rating clamp 0..5 → entero. */
export function clampStars(value: number | null | undefined): number {
  if (!value) return 5;
  return Math.max(0, Math.min(5, Math.round(value)));
}

export const eventKindCopy: Record<UpcomingEvent['kind'], string> = {
  ceremonia: 'Ceremonia',
  taller: 'Taller',
  experiencia: 'Experiencia',
  ritual: 'Ritual',
};

export const eventModalityCopy: Record<UpcomingEvent['modality'], string> = {
  presencial: 'Presencial',
  online: 'Online',
  hibrido: 'Híbrido',
};
